import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse, handleAjaxError,
} from 'root/DataFunctions/BaseDataFns';


export const genericListboxFetch = ({url, keyFieldName, labelFieldName, additionalFields, filterFn, mapFn, postProcessingFn}) =>
{
    return new Promise((resolve, reject) =>
    {
        if (url === null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                let rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                // Perform any custom transformations on the data returned from the API
                if ( mapFn !== undefined )
                {
                    rows = rows.map((rec) =>
                    {
                        return mapFn(rec) ;
                    })
                }

                // Perform any custom filtering
                if ( filterFn !== undefined )
                {
                    if ( typeof filterFn !== 'function' )
                    {
                        throw new Error ("Invalid filter Function passed to genericListboxFetch") ;
                    }
                    else
                    {
                    rows = rows.filter((rec) =>
                    {
                        return filterFn(rec) ;
                    })
                }
                }

                // Map the data into the format the listbox wants.
                // Each listbox will map the value and label elements from the returned listbox data
                const rval =  rows.map((entry) =>
                {
                    let arr = {} ;

                    // Add any additional fields to the response
                    if ( additionalFields !== undefined )
                    {
                        let initialValue = {};
                        arr = additionalFields.reduce((obj, item) => {
                            return {
                                ...obj,
                                [item]: entry[item],
                            };
                        }, initialValue);
                    }

                    return { value: +(entry[keyFieldName]), label: entry[labelFieldName], ...arr} ;
                }) ;

                // Perform any post-processing
                if ( postProcessingFn !== undefined )
                {
                    const f =  postProcessingFn (rval) ;
                    resolve (  f );
                }
                else
                {
                    resolve ( rval );
                }
            })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error) ;

                reject(jqXHR, textStatus, error);
            });
        }
    });
}
